const DashboardUpdatetextItem = ({date, feature, featureText, bugfix, bugfixText, lastUpdate, onClick, activeUpdateText, id, featureKinoheld='', featureCompeso='', bugfixKinoheld='', bugfixCompeso='', kinoheldClient=false, compesoClient=false, marsClient=false, featureMars=''}) => {
    const additionalClass = lastUpdate ? 'update-text-open' : activeUpdateText === id ? 'update-text-open' : 'update-text-close' 

    return (
        <div className={"" + additionalClass}>
            {onClick ? (<p onClick={()=>onClick(additionalClass, id)} className="update-title cursor-pointer title-large-color gap-10">{date}</p>)
            :
            (<p className="title-large-color gap-10">{date}</p>)}
            <div className="update-text-content">
                {(feature || featureCompeso && compesoClient) && <p className="text-regular-color text-regular-uppercase">
                    NEW FEATURE / NEUES FEATURE
                </p>}
                {feature &&
                    <p className="text-regular gap-35" dangerouslySetInnerHTML={{ __html: featureText}}/>
                }
                {compesoClient &&
                    <p className="text-regular gap-35" dangerouslySetInnerHTML={{ __html: featureCompeso}}/>
                }
                {marsClient &&
                    <p className="text-regular gap-35" dangerouslySetInnerHTML={{ __html: featureMars}}/>
                }
                {kinoheldClient &&
                    <p className="text-regular gap-35" dangerouslySetInnerHTML={{ __html: featureKinoheld}}/>
                }
                {bugfix && <p className="text-regular-color text-regular-uppercase">
                    BUGFIX
                </p>}
                {bugfix &&
                    <p className="text-regular gap-35" dangerouslySetInnerHTML={{ __html: bugfixText}}/>
                }
                {compesoClient &&
                    <p className="text-regular gap-35" dangerouslySetInnerHTML={{ __html: bugfixCompeso}}/>
                }
                {kinoheldClient &&
                    <p className="text-regular gap-35" dangerouslySetInnerHTML={{ __html: bugfixKinoheld}}/>
                }
            </div>
        </div>
    )
}

export default DashboardUpdatetextItem
